<template>
  <div>
    <DropDownList
      :classNames="classNames"
      :customKey="true"
      :isLargeDropDown="false"
      itemSection="Item Table Action Bar"
      :menuSections="searchContextMenuSections"
      menuFontSize="small"
      :showList="showList"
      :showMenuLabel="true"
    />
  </div>
</template>

<script>
import {
  SystemSearchConsts,
} from 'client/util/Constants';
import { mapActions, mapGetters } from 'vuex';
import DropDownList from 'client/components/DropDownMenu/DropDownList.vue';

const {
  displayName,
  systemID,
} = SystemSearchConsts;

export default {
  name: 'PolicySystemStatusSearchFilter',

  components: {
    DropDownList,
  },

  props: {
    setSearchInputValue: {
      type: Function,
      required: true,
    },
  },

  data() {
    const classNames = {
      dropDownList: 'searchContext',
    };

    return {
      classNames,
      showList: false,
    };
  },

  computed: {
    ...mapGetters('ConfigurationModel', {
      policyData: 'item',
    }),

    ...mapGetters('PolicySystemStatusCollection', {
      searchTerm: 'getSearchTerm',
    }),

    ...mapGetters('SystemCollection', {
      systems: 'getCollection',
    }),

    menuItems() {
      return this.systems.map(item => ({
        menuLabel: item.id,
        label: item.displayName,
        action: () => { this.handleDropdownAction(item); },
      }));
    },

    searchContextMenuSections() {
      return [
        {
          menuLabel: 'Systems:',
          menuItems: this.menuItems,
        },
      ];
    },
  },

  watch: {
    searchTerm() {
      this.fetchDevices(this.searchTerm);
    },
  },

  methods: {
    ...mapActions('SystemCollection', [
      'fetchCollection',
      'setSearchTerm',
      'setFilter',
    ]),

    async fetchDevices(deviceName) {
      const filter = {
        name: 'osFamily',
        operator: 'eq',
        value: this.policyData.template.osMetaFamily,
      };

      this.setSearchTerm({ searchTerm: deviceName, preventReset: false });
      this.setFilter({ filter });

      await this.fetchCollection();

      if (!this.searchTerm.includes(systemID)) {
        this.showList = this.systems.length > 0 && deviceName.length > 0;
      }
    },

    handleDropdownAction(item) {
      const customSearch = {
        item: {
          id: item.id,
          displayName: item.displayName,
        },
        searchBy: systemID,
        inputText: displayName,
      };
      this.setSearchInputValue(customSearch, true);
      this.showList = false;
    },
  },
};
</script>
